import { render } from "./PhotoLightbox.vue?vue&type=template&id=336b365e&scoped=true"
import script from "./PhotoLightbox.vue?vue&type=script&lang=js"
export * from "./PhotoLightbox.vue?vue&type=script&lang=js"

import "./PhotoLightbox.vue?vue&type=style&index=0&id=336b365e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-336b365e"]])

export default __exports__